import { CartSavedProductsSkeleton } from './CartSavedProducts.Skeleton';

export function CartRecommendationsSkeleton() {
  return <CartSavedProductsSkeleton recommendations />;
}
